import { render, staticRenderFns } from "./q12.vue?vue&type=template&id=a03ba682&scoped=true&"
import script from "./q12.vue?vue&type=script&lang=js&"
export * from "./q12.vue?vue&type=script&lang=js&"
import style0 from "./q12.vue?vue&type=style&index=0&id=a03ba682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ba682",
  null
  
)

export default component.exports